export enum JobDetailsTabs {
  OVERVIEW = 'Overview',
  BILLING = 'Billing',
  HISTORY = 'History'
}

export enum ReferralsEarningsTabs {
  REFERRALS = 'Referrals',
  EARNINGS = 'Earnings'
}

export enum ExpenseTabs {
  TEAM = 'TEAM',
  COMPANY = 'COMPANY'
}

export enum JobDetailsTabs {
  Overview = 'Overview',
  History = 'History',
  Billing = 'Billing'
}
